module.exports = __webpack_public_path__ + "img/elementheights_jasp.0868f1f0.png";